const NoPage = () => {
  const ret = <>
    <h1>404</h1>
    <a href="/" rel="noopener noreferrer">gehe zu  Home</a>

  </>;
  return ret;
};

export default NoPage;